import { BaseApiClient } from "./BaseApiClient";
export const MARKETS_ENDPOINTS = {
    BY_EVENT_ID: "/Markets/GetByEventId"
};
/**
 * MarketsApiClient - client for fetching Markets BFF endpoints
 * @export
 * @class MarketsApiClient
 * @extends {BaseApiClient}
 */
export class MarketsApiClient extends BaseApiClient {
    /**
     * Fetch markets by id from BFF
     * @param {request} MarketsByEventIdRequest
     * @throws {RequiredError}
     * @memberof MarketsApiClient
     */
    getByEventId(request) {
        let fetchOptions = {
            request,
            fetchOptOverride: {}
        };
        return this.executeRequest(MARKETS_ENDPOINTS.BY_EVENT_ID, fetchOptions);
    }
}
//# sourceMappingURL=MarketsApiClient.js.map